<!-- <p>new-complaint works!</p> -->
<!-- <p>data-entry-complaint-form works!</p> -->
<app-spinner></app-spinner>
<div class="row">
  <div class="col-12" style="text-align: right; padding: 10px 20px;">
    <h4 class="dashboard cursor-pointer hover-blue" style="color: rgb(24, 107, 202);" (click)="back()" role="button">
      < Back </h4>

  </div>
</div>
<div class="container-fluid">
  <div class="row" style="flex-shrink: 0;">
    <div class="col-12">
      <h3 class="complaint-submit">Submit a Complaint</h3>
      <p class="instruction" style="white-space: normal; word-wrap: break-word !important;">Please fill out the form below with details about your complaint. Our team will review
        <br>and address your
        concern promptly.</p>
    </div>
  </div>
  <div class="row" style="height: fit-content;">
    <div class="col-12" style="height: fit-content;">
      <mat-card class="example-card px-2 my-3" appearance="outlined">
        <form [formGroup]="complaint_form" (ngSubmit)="onSubmit()">
          <div class="form-row pt-2" style="display: flex; flex-direction: row; gap: 20px;">
            <div>
              <mat-label>Full Name <span style="color: red;">*</span></mat-label><br>
              <mat-form-field class="pt-1 common-field" appearance="outline">
                <input name="full_name" matInput (keypress)="allowOnlyKeysForName($event)" formControlName="full_name" 
                  required placeholder="Enter Full Name" maxlength="250">
                <mat-error *ngIf="complaint_form.get('full_name')?.hasError('required')">
                  Full Name is required
                </mat-error>
                <mat-error *ngIf="complaint_form.get('full_name')?.hasError('pattern')">
                  Name cannot start with a space or contain numbers/special characters
                </mat-error>
                <mat-error
                  *ngIf="complaint_form.get('full_name')?.hasError('maxlength') && complaint_form.get('full_name')?.touched">
                  Full Name cannot exceed 250 characters
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-label>Mobile Number <span style="color: red;">*</span></mat-label><br>
              <mat-form-field class="pt-1 common-field" appearance="outline">
                <input name="mobile_no" matInput  formControlName="mobile_no" (keypress)="allowOnlyKeysForMobile($event)"
                  required type="tel" placeholder="Enter Mobile No." maxlength="10" />
                <mat-error *ngIf="complaint_form.get('mobile_no')?.hasError('invalidMobile')">
                  Please enter a valid 10 digits mobile number start with greater than 5.
                </mat-error>
                <mat-error *ngIf="complaint_form.get('mobile_no')?.hasError('pattern')">
                  Please enter a valid 10 digits mobile number start with greater than 5.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div>
            <label class="section-lable" style="display: flex; margin-top:10px;">
              Complaint Department<span style="color: red;">*</span>
            </label>
            <div class="checkbox-grid pt-2">
              <span *ngFor="let element of allDepartment">
                <mat-checkbox name="checkbox" [formControlName]="element['dep_cd']" class="example-card1 pt-2"
                  style="width:100%;" (click)="getResolver()">
                  {{element.department_name}}
                  <small> &nbsp;&nbsp;&nbsp;</small>
                </mat-checkbox>
              </span>
              <!-- <mat-checkbox formControlName="drinking_water" class="example-card1 pt-2">
                Related with Drinking
                Water and Sewer <br><small>सफाई से सम्बन्धित</small>
              </mat-checkbox> -->
              <!-- <mat-checkbox formControlName="road_repair" class="example-card1 pt-2">
                Related with repair of
                Roads, Drains and Culverts <br><small>सड़क, नाली, पुलिया की
                  मरम्मत सम्बन्धित</small>
              </mat-checkbox>
              <mat-checkbox formControlName="streat_light" class="example-card1 pt-2">
                Street Light<br><small>मार्ग प्रकाश</small>
              </mat-checkbox>
              <mat-checkbox formControlName="tax" class="example-card1 pt-2">
                Related with Tax<br><small>मार्ग प्रकाश</small>
              </mat-checkbox>
              <mat-checkbox formControlName="encroachment" class="example-card1 pt-2">
                Encroachment<br><small>अतिक्रमण</small>
              </mat-checkbox>
              <mat-checkbox formControlName="animals" class="example-card1 pt-2">
                Related with Animals <br><small>पशु सम्बन्धित</small>
              </mat-checkbox>
              <mat-checkbox formControlName="health_water" class="example-card1 pt-2">
                Related with Health
                Water and Sewer<br><small>स्वासय सम्बन्धित</small>
              </mat-checkbox>
              <mat-checkbox formControlName="others" class="example-card1 pt-2">
                Other Grievances<br><small>अन्य प्रकार की शिकायते</small>
              </mat-checkbox> -->
              <div *ngIf="complaint_form.errors?.['atLeastOneRequired'] && complaint_form.touched" style="color: red;">
                Please select at least one option.
              </div>
            </div>
          </div>
          <mat-label>Complaint Description<span style="color: red;">*</span><small>(0/500
              characters)</small></mat-label>
          <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
            <textarea name="complaint_desc" matInput rows="4"  formControlName="complaint_desc" required maxlength="500"
              placeholder="Please describe your complaint in detail"></textarea>
            <mat-hint align="end">
              {{ complaint_form.get('complaint_desc')?.value?.length || 0 }}/500
            </mat-hint>
            <mat-error
              *ngIf="complaint_form.get('complaint_desc')?.hasError('required') && complaint_form.get('complaint_desc')?.touched">
              Description is required
            </mat-error>
            <mat-error
              *ngIf="complaint_form.get('complaint_desc')?.hasError('maxlength') && complaint_form.get('complaint_desc')?.touched">
              Description cannot exceed 500 characters
            </mat-error>
            <mat-error
              *ngIf="complaint_form.get('complaint_desc')?.hasError('leadingWhitespace') && complaint_form.get('complaint_desc')?.touched">
              Description cannot start with space
            </mat-error>
          </mat-form-field>

          <div class="row pt-4">
            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <mat-label>Zone <span style="color: red;">*</span></mat-label><br>
              <mat-form-field appearance="outline" class="w-100" style=" margin-bottom:-20px; margin-top: 5px;">
                <mat-select name="zone" placeholder="Select" formControlName="zone_cd"  required>
                  <mat-option *ngFor="let element of zoneArr" [value]="element.zone_cd"
                    (click)="changeZone(element.zone_cd)">{{ element.zone}}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="complaint_form.get('zone')?.hasError('required') && complaint_form.get('zone')?.touched">
                  Selecting a zone First
                </mat-error>
              </mat-form-field><br>
              <small *ngIf="!(complaint_form.get('zone')?.hasError('required') && complaint_form.get('zone')?.touched)">
                Zone selection is required
              </small>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <mat-label>Ward <span style="color: red;">*</span></mat-label><br>
              <mat-form-field appearance="outline" class="w-100" style="margin-bottom:-20px; margin-top: 5px;">
                <mat-select name="ward" placeholder="First select the Ward" formControlName="ward" required>
                  <mat-option *ngFor="let element of wordArr" [value]="element" (click)="wordChange()">
                    {{ element }}
                  </mat-option>
                </mat-select>

                <mat-error
                  *ngIf="complaint_form.get('ward')?.hasError('required') && complaint_form.get('ward')?.touched">
                  Selecting a ward is required
                </mat-error>
              </mat-form-field><br>

              <small *ngIf="!(complaint_form.get('ward')?.hasError('required') && complaint_form.get('ward')?.touched)">
                Ward selection is required
              </small>
            </div>


            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <mat-label>Mohalla <span style="color: red;">*</span></mat-label><br>
              <mat-form-field appearance="outline" class="w-100" style="margin-top: 5px;">
                <mat-select name="mohalla" formControlName="mohalla" placeholder="Select">
                  <mat-option *ngFor="let element of mohallaArr" [value]="element.mohalla">{{ element.mohalla
                    }}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="complaint_form.get('mohalla')?.hasError('required') && complaint_form.get('mohalla')?.touched">
                  Selecting a mohalla is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <mat-label>Officer Name <span style="color: red;">*</span></mat-label><br>
              <mat-form-field appearance="outline" class="w-100" style="margin-top: 5px;">
                <mat-select name="officer" formControlName="resolver_user_id"  placeholder="Select">
                  <mat-option *ngFor="let element of resolverArr" [value]="element.user_id">{{ element.party_name }}
                    ({{element.role_cd}})</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="complaint_form.get('resolver_user_id')?.hasError('required') && complaint_form.get('resolver_user_id')?.touched">
                  Officer Name is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; gap: 20px;" class="mt-5 form-row">
            <div class="w-50 file-field">
              <mat-label>Upload Document (optional)</mat-label>
              <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%; margin-bottom:-20px;"
                (click)="fileInput.click()"> -->
              <!-- <input matInput [value]="uploaded_fileName" formControlName="uploaded_fileName" readonly
                  placeholder="Upload" /> -->
              <input #comDocInput type="file" name="com_doc" id="mapFileInput" accept="application/pdf"
                (change)="checkFile($event,'com')" style="margin-top: 5px;" #fileInputl 
                class="upload-box form-control" required />
              <p (click)="view('com')" class="text-right text-primary"
                style="text-decoration: underline; cursor: pointer;"
                *ngIf="selectedFileUrlObj['com'] &&  selectedFileUrlObj['com']['url']">click here to view </p>
              <!-- <button mat-icon-button matSuffix aria-label="Upload file">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.5 5L13.2071 4.29289L12.5 3.58579L11.7929 4.29289L12.5 5ZM11.5 17C11.5 17.5523 11.9477 18 12.5 18C13.0523 18 13.5 17.5523 13.5 17L11.5 17ZM18.5 11L19.2071 10.2929L13.2071 4.29289L12.5 5L11.7929 5.70711L17.7929 11.7071L18.5 11ZM12.5 5L11.7929 4.29289L5.79289 10.2929L6.5 11L7.20711 11.7071L13.2071 5.70711L12.5 5ZM12.5 5L11.5 5L11.5 17L12.5 17L13.5 17L13.5 5L12.5 5Z"
                      fill="#33363F" />
                    <path d="M5.5 21L19.5 21" stroke="#33363F" stroke-width="2" />
                  </svg>
                </button> -->
              <!-- <input type="file" #fileInput style="display: none" /> -->
              <!-- </mat-form-field> -->
              <small>Upload 1 or more images related to your complaint (Max size: 5MB)</small>
            </div>
            <div class="w-50 file-field">
              <mat-label>Other Document (optional)</mat-label>
              <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%;margin-bottom:-20px;"
                (click)="fileInput.click()">
                <input matInput [value]="uploaded_fileName" formControlName="uploaded_fileName" readonly
                  placeholder="Upload" />
                <button mat-icon-button matSuffix aria-label="Upload file">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.5 5L13.2071 4.29289L12.5 3.58579L11.7929 4.29289L12.5 5ZM11.5 17C11.5 17.5523 11.9477 18 12.5 18C13.0523 18 13.5 17.5523 13.5 17L11.5 17ZM18.5 11L19.2071 10.2929L13.2071 4.29289L12.5 5L11.7929 5.70711L17.7929 11.7071L18.5 11ZM12.5 5L11.7929 4.29289L5.79289 10.2929L6.5 11L7.20711 11.7071L13.2071 5.70711L12.5 5ZM12.5 5L11.5 5L11.5 17L12.5 17L13.5 17L13.5 5L12.5 5Z"
                      fill="#33363F" />
                    <path d="M5.5 21L19.5 21" stroke="#33363F" stroke-width="2" />
                  </svg>
                </button>
                <input type="file" #fileInput style="display: none" />
              </mat-form-field> -->
              <input name="invoiceFile" #othersDocInput type="file" id="mapFileInput" accept="application/pdf"
                (change)="checkFile($event,'others')" style="margin-top: 5px;" #fileInputl  
                class="upload-box form-control" required />
              <p (click)="view('others')" class="text-right text-primary"
                style="text-decoration: underline; cursor: pointer;"
                *ngIf="selectedFileUrlObj['others'] &&  selectedFileUrlObj['others']['url']">click here to view </p>
              <small>(Max size: 5MB)</small>
            </div>

          </div>
          <br><br>
        </form>


        <form [formGroup]="intant_resolve_form" (ngSubmit)="onSubmit()" style="margin-bottom: 20px;">
          <div class="addextafieldcheckbox pt-2 ps-2 mt-4">
            <p class="resolution-status">Instant Resolution Details</p>
            <mat-checkbox name="is_ressolve" formControlName="is_instant_resolved"  style="margin-bottom: 30px;"
              (click)="showHiddenFields()">
              Mark as Resolved Instantly <br />
              <small>
                Check this if the complaint has been resolved immediately by the authority.
                Otherwise, it will be scheduled for resolution within <span
                  *ngIf="allEscalationRule[0] && allEscalationRule[0]['time'] ; else escalationRule"><b>{{allEscalationRule[0]['time']}}</b>
                  hours</span> <ng-template #escalationRule><b>7</b> days.</ng-template>
              </small>
            </mat-checkbox>
            <div *ngIf="is_instant_resolved" class="extra-fields mt-3">
              <div class="row form-row d-flex mt-5 px-2" style="justify-content: space-between;">
                <div class="col-6 common-field1" style="padding: 0; margin: 0;">
                  <mat-label>Remark<span style="color: red;">*</span><small>(0/500
                      characters)</small></mat-label>
                  <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
                    <textarea name="remarks" matInput rows="4"  formControlName="resolved_remark" required
                      placeholder="Please provide your remarks" maxlength="500"
                      style="resize: vertical; word-wrap: break-word; overflow-wrap: break-word;"></textarea>

                    <mat-hint align="end">
                      {{ intant_resolve_form.get('resolved_remark')?.value?.length || 0 }}/500
                    </mat-hint>

                    <mat-error *ngIf="intant_resolve_form.get('resolved_remark')?.hasError('required') &&
                      intant_resolve_form.get('resolved_remark')?.touched">
                      Remark is required
                    </mat-error>

                    <mat-error *ngIf="intant_resolve_form.get('resolved_remark')?.hasError('maxlength') &&
                        intant_resolve_form.get('resolved_remark')?.touched">
                      Remark cannot exceed 500 characters
                    </mat-error>
                    <mat-error
                      *ngIf="intant_resolve_form.get('resolved_remark')?.hasError('leadingWhitespace') && intant_resolve_form.get('resolved_remark')?.touched">
                      Remark cannot start with space
                    </mat-error>
                  </mat-form-field>

                </div>
                <div class="col-6 common-field1" style="padding: 0; margin: 0; ">
                  <mat-label>Approval Description<span style="color: red; padding: 0; margin: 0;">*</span><small>(0/500
                      characters)</small></mat-label>
                  <mat-form-field appearance="outline" class="full-width" style="width: 100%; height: 150px;">
                    <textarea name="approval" matInput rows="4"  formControlName="approval_desc" required
                      placeholder="Please provide your remarks" maxlength="500"
                      style="resize: vertical; word-wrap: break-word; overflow-wrap: break-word;"></textarea>
                    <mat-hint align="end">
                      {{ intant_resolve_form.get('approval_desc')?.value?.length || 0 }}/500
                    </mat-hint>

                    <mat-error *ngIf="intant_resolve_form.get('approval_desc')?.hasError('required') &&
                      intant_resolve_form.get('approval_desc')?.touched">
                      Approval Description is required
                    </mat-error>

                    <mat-error *ngIf="intant_resolve_form.get('approval_desc')?.hasError('maxlength') &&
                        intant_resolve_form.get('approval_desc')?.touched">
                      Approval Description cannot exceed 500 characters
                    </mat-error>
                    <mat-error
                      *ngIf="intant_resolve_form.get('approval_desc')?.hasError('leadingWhitespace') && intant_resolve_form.get('approval_desc')?.touched">
                      Approval Description cannot start with space
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <mat-label>Upload Image or Document (optional)</mat-label>
              <input name="invoiceFile" #resolvedDocInput type="file" id="mapFileInput" accept="application/pdf"
                (change)="checkFile($event,'resolved')" style="margin-top: 5px;" #fileInputl
                class="upload-box form-control" required />
              <p (click)="view('resolved')" class="text-right text-primary"
                style="text-decoration: underline; cursor: pointer;"
                *ngIf="selectedFileUrlObj['resolved'] &&  selectedFileUrlObj['resolved']['url']">click here to view </p>
              <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%; margin-bottom:-20px;"
                (click)="fileInput.click()">
                <input matInput [value]="uploaded_fileName" formControlName="uploaded_fileName" readonly />
                <button mat-icon-button matSuffix aria-label="Upload file">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.5 5L13.2071 4.29289L12.5 3.58579L11.7929 4.29289L12.5 5ZM11.5 17C11.5 17.5523 11.9477 18 12.5 18C13.0523 18 13.5 17.5523 13.5 17L11.5 17ZM18.5 11L19.2071 10.2929L13.2071 4.29289L12.5 5L11.7929 5.70711L17.7929 11.7071L18.5 11ZM12.5 5L11.7929 4.29289L5.79289 10.2929L6.5 11L7.20711 11.7071L13.2071 5.70711L12.5 5ZM12.5 5L11.5 5L11.5 17L12.5 17L13.5 17L13.5 5L12.5 5Z"
                      fill="#33363F" />
                    <path d="M5.5 21L19.5 21" stroke="#33363F" stroke-width="2" />
                  </svg>
                </button>
                <input type="file" #fileInput style="display: none" placeholder="Upload" />
              </mat-form-field> -->
              <small>(Max size: 5MB)</small>
              <div class="text-center mt-5">
                <button style="background-color: #226CE0; color: white; text-align: center;" mat-raised-button>Submit
                  Complaint</button>
              </div>
            </div>
            <div class="text-center mt-5" *ngIf="!is_instant_resolved">
              <button style="background-color: #226CE0; color: white; text-align: center;" mat-raised-button>
                Submit Complaint
              </button>
            </div>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</div>